<form class="grid grid-cols-1 gap-4 w-full sm:grid-cols-2 lg:grid-cols-3" [formGroup]="searchFormGroup">
    <div class="flex w-full flex-col gap-2">
        <sh-input-text [label]="firstNameLabel()" [formControl]="firstNameControl" />
    </div>

    <div class="flex w-full flex-col gap-2">
        <sh-input-text [label]="lastNameLabel()" [formControl]="surnameControl" />
    </div>

    <div class="flex w-full flex-col gap-2">
        <sh-input-text [label]="gidLabel()" [formControl]="employeeIdControl" />
    </div>
</form>
